import { createSlice } from "@reduxjs/toolkit";
import { transactionDetailAPI } from "../../api/customer";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const transactionDetailSlice = createSlice({
  name: "transactionDetail",
  initialState: data,
  reducers: {
   transactionDetailSlice(state) {
      state.isLoading = true;
    },
   transactionDetailSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    transactionDetailSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   transactionDetailSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const transactionDetailHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(transactionDetailAction.transactionDetailSlice());
    const response: any = await transactionDetailAPI(id);
    dispatch(transactionDetailAction.transactionDetailSliceSuccess(response));
  } catch (e: any) {
    dispatch(transactionDetailAction.transactionDetailSliceFailure(e?.response?.data));
  }
};
export default transactionDetailSlice.reducer;
export const transactionDetailAction = transactionDetailSlice.actions;
